export const ActiveShippingLocationsColumnId = 'ActiveShippingLocations';

export const baseColumnsDefaultConfigs = [
  {
    id: 'AliasSKUs',
    mappedId: 'alias',
    width: 125,
    index: 0,
    pinned: false,
    nonsortable: true,
    minWidth: 70,
  },
  {
    id: 'SKU',
    mappedId: 'sku',
    width: 150,
    index: 1,
    pinned: false,
    minWidth: 70,
  },
  {
    id: 'ProductProfileID',
    mappedId: 'productProfileId',
    width: 105,
    index: 2,
    pinned: false,
    minWidth: 70,
  },
  {
    id: 'WeightOz',
    mappedId: 'weight',
    width: 110,
    index: 3,
    pinned: false,
    minWidth: 70,
  },
  {
    id: 'Name',
    mappedId: 'name',
    width: 380,
    index: 4,
    pinned: false,
    minWidth: 70,
  },
  {
    id: ActiveShippingLocationsColumnId,
    mappedId: 'activeShippingLocations',
    width: 200,
    pinned: false,
    index: 5,
    minWidth: 200,
    nonsortable: true,
  },
  {
    id: 'WarehouseLocation',
    mappedId: 'warehouseLocation',
    width: 160,
    index: 6,
    pinned: false,
    minWidth: 70,
  },
  {
    id: 'Active',
    mappedId: 'active',
    width: 80,
    index: 7,
    pinned: false,
    minWidth: 80,
  },
  {
    id: 'IsBundle',
    mappedId: 'bundle',
    width: 105,
    index: 7,
    pinned: false,
    minWidth: 70,
  },
  {
    id: 'CreateDate',
    mappedId: 'createDateUTC',
    width: 110,
    index: 8,
    pinned: false,
    minWidth: 105,
  },
  {
    id: 'ThumbnailUrl',
    mappedId: 'thumbnailUrl',
    width: 105,
    index: 9,
    pinned: false,
    nonsortable: true,
    minWidth: 65,
  },
  {
    id: 'Allocated',
    mappedId: 'allocated',
    width: 105,
    index: 10,
    pinned: false,
    nonsortable: true,
    minWidth: 70,
  },
  {
    id: 'Available',
    mappedId: 'available',
    width: 105,
    index: 11,
    pinned: false,
    nonsortable: true,
    minWidth: 80,
  },
  {
    id: 'CustomsValue',
    mappedId: 'declaredValue',
    width: 105,
    index: 12,
    pinned: false,
    nonsortable: true,
    minWidth: 70,
  },
  {
    id: 'Dimensions',
    mappedId: 'dimensions',
    width: 220,
    index: 13,
    pinned: false,
    minWidth: 70,
    nonsortable: true,
  },
  {
    id: 'FillSku',
    mappedId: 'fulfillmentSKU',
    width: 105,
    index: 14,
    pinned: false,
    minWidth: 70,
    nonsortable: true,
  },
  {
    id: 'CustomsTariffNo',
    mappedId: 'customsTariffNo',
    width: 150,
    index: 15,
    pinned: false,
    nonsortable: true,
    minWidth: 70,
  },
  {
    id: 'ProviderID',
    mappedId: 'serviceId',
    width: 150,
    index: 16,
    pinned: false,
    nonsortable: true,
    minWidth: 70,
  },
  {
    id: 'IntlProviderID',
    mappedId: 'intlServiceId',
    width: 150,
    index: 17,
    pinned: false,
    nonsortable: true,
    minWidth: 70,
  },
  {
    id: 'Stock',
    mappedId: 'stock',
    width: 105,
    index: 18,
    pinned: false,
    nonsortable: true,
    minWidth: 80,
  },
  {
    id: 'ProductType',
    mappedId: 'productType',
    width: 105,
    index: 19,
    pinned: false,
    minWidth: 70,
  },
  {
    id: 'Tags',
    mappedId: 'tags',
    width: 105,
    index: 20,
    pinned: false,
    minWidth: 70,
    nonsortable: true,
  },
  {
    id: 'UPC',
    mappedId: 'upc',
    width: 105,
    index: 21,
    pinned: false,
    minWidth: 70,
  },
  {
    id: 'ProductVariantsCount',
    mappedId: 'productVariantIds',
    width: 105,
    index: 22,
    pinned: false,
    nonsortable: true,
    minWidth: 70,
  },
  {
    id: 'CategoryId',
    mappedId: 'categoryId',
    width: 105,
    index: 23,
    pinned: false,
    minWidth: 70,
  },
  {
    id: 'ModifyDate',
    mappedId: 'modifyDateUTC',
    width: 115,
    index: 24,
    pinned: false,
    minWidth: 111,
  },
  {
    id: 'AvailableInventoryCounts',
    mappedId: 'totalAvailable',
    width: 100,
    index: 25,
    pinned: false,
    minWidth: 100,
    nonsortable: true,
  },
  {
    id: 'AutoSplit',
    mappedId: 'autoSplit',
    width: 150,
    index: 26,
    pinned: false,
    minWidth: 70,
    nonsortable: true,
  },
  {
    id: 'Committed',
    mappedId: 'committed',
    width: 120,
    index: 25,
    pinned: false,
    minWidth: 70,
    nonsortable: true,
  },
  {
    id: 'Inbound',
    mappedId: 'inbound',
    width: 100,
    index: 26,
    pinned: false,
    minWidth: 70,
    nonsortable: true,
  },
  {
    id: 'Inventory',
    mappedId: 'inventory',
    width: 100,
    index: 25,
    pinned: false,
    minWidth: 100,
    nonsortable: true,
  },
];

export const defaultColumnConfig = [
  {
    id: 'SKU',
    mappedId: 'sku',
    width: 150,
    pinned: true,
    minWidth: 70,
    index: 1,
  },
  {
    id: 'ThumbnailUrl',
    mappedId: 'thumbnailUrl',
    width: 65,
    index: 2,
    pinned: false,
    nonsortable: true,
    minWidth: 65,
  },
  {
    id: 'Name',
    mappedId: 'name',
    width: 380,
    pinned: false,
    minWidth: 70,
    index: 3,
  },
  {
    id: 'Inventory',
    mappedId: 'inventory',
    width: 100,
    index: 4,
    pinned: false,
    minWidth: 100,
    nonsortable: true,
  },
  {
    id: 'Inbound',
    mappedId: 'inbound',
    width: 100,
    index: 5,
    pinned: false,
    minWidth: 70,
    nonsortable: true,
  },
  {
    id: 'Active',
    mappedId: 'active',
    width: 80,
    pinned: false,
    minWidth: 80,
    index: 6,
  },
  {
    id: 'CreateDate',
    mappedId: 'createDateUTC',
    width: 110,
    pinned: false,
    minWidth: 105,
    index: 7,
  },
  {
    id: 'ModifyDate',
    mappedId: 'modifyDateUTC',
    width: 115,
    pinned: false,
    minWidth: 111,
    index: 8,
  },
];

export const sortedColumnConfig = baseColumnsDefaultConfigs.toSorted((a, b) => {
  return a.id.localeCompare(b.id);
});
